import { CatalogMoldSize } from "@/pages/caster/models/catalogs/CatalogMoldSize";
import {
	DefaultMenuItem,
	GetContextMenuItemsParams,
	MenuItemDef,
} from "ag-grid-community";
import React from "react";
interface Props {
	rows: CatalogMoldSize[];
	selectedRowId: string;
	setSelectedRowId: (id: string) => void;
	showContextMenu: (event: any, data: any, context: string) => void;
}
export const useGetMenuOptions = ({
	rows,
	selectedRowId,
	setSelectedRowId,
	showContextMenu,
}: Props) => {
	const getContextMenuItems = React.useCallback(
		(params: GetContextMenuItemsParams): (DefaultMenuItem | MenuItemDef)[] => {
			const data = params.node?.data;
			showContextMenu(event as any, data, "moldSizeContext");
			if (selectedRowId) {
				const previousRow = document.querySelector(
					`.ag-row[row-id="${selectedRowId}"]`,
				);
				if (previousRow) previousRow.classList.remove("custom-selected");
			}
			if (params && params.node && params.node.id) {
				setSelectedRowId(params.node.id);
				const currentRow = document.querySelector(
					`.ag-row[row-id="${params.node.id}"]`,
				);
				if (currentRow) currentRow.classList.add("custom-selected");
			}
			return [];
		},
		[rows],
	);

	return { getContextMenuItems };
};
